import React from "react";
import { Form } from "react-bootstrap";
import AppSelect from "./ui/AppSelect";

const VendorSelector = ({ vendors, selectedVendorId, onChange, className }) => {
  // Group vendors by type
  const groupedVendors = {
    RESTAURANT: [],
    RETAILER: [],
    WHOLESALER: [],
    HEALTHCARE: [],
    BRAND: [],
  };

  vendors.forEach((vendor) => {
    const type = vendor.vendorType || vendor.operationMode;
    if (groupedVendors[type]) {
      groupedVendors[type].push(vendor);
    }
  });

  const vendorStyles = {
    select: {
      padding: "12px 16px",
      borderRadius: "8px",
      border: "2px solid #e2e8f0",
      fontSize: "14px",
      fontWeight: "500",
      backgroundColor: "#ffffff",
      color: "#737d8f",
      cursor: "pointer",
      transition: "all 0.25s ease",
      outline: "none",
      minWidth: "280px",
    },
    label: {
      fontSize: "14px",
      fontWeight: "600",
      color: "#4a5568",
      marginBottom: "8px",
      display: "block",
    },
    wrapper: {
      display: "flex",
      flexDirection: "column",
    },
    optgroup: {
      fontWeight: "700",
      color: "#2d3748",
      fontSize: "13px",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
    },
    option: {
      padding: "8px 12px",
      fontSize: "14px",
      color: "#4a5568",
    },
  };

  return (
    <div style={vendorStyles.wrapper} className={className}>
      <label style={vendorStyles.label} htmlFor="vendor-select">
        Filter by Vendor
      </label>
      <AppSelect
        id="vendor-select"
        value={selectedVendorId || "all"}
        onChange={(e) => onChange(e.target.value === "all" ? null : e.target.value)}
        style={vendorStyles.select}
        onFocus={(e) => {
          e.target.style.borderColor = "#4299e1";
          e.target.style.boxShadow = "0 0 0 3px rgba(66, 153, 225, 0.1)";
        }}
        onBlur={(e) => {
          e.target.style.borderColor = "#e2e8f0";
          e.target.style.boxShadow = "none";
        }}
      >
        <option value="all">All Vendors (All Types)</option>

        {groupedVendors.RESTAURANT.length > 0 && (
          <optgroup
            label={`RESTAURANTS (${groupedVendors.RESTAURANT.length})`}
            style={vendorStyles.optgroup}
          >
            {groupedVendors.RESTAURANT.map((vendor) => (
              <option
                key={vendor._id}
                value={vendor._id}
                style={vendorStyles.option}
              >
                {vendor.name}
              </option>
            ))}
          </optgroup>
        )}

        {groupedVendors.RETAILER.length > 0 && (
          <optgroup
            label={`RETAIL VENDORS (${groupedVendors.RETAILER.length})`}
            style={vendorStyles.optgroup}
          >
            {groupedVendors.RETAILER.map((vendor) => (
              <option
                key={vendor._id}
                value={vendor._id}
                style={vendorStyles.option}
              >
                {vendor.name}
              </option>
            ))}
          </optgroup>
        )}

        {groupedVendors.WHOLESALER.length > 0 && (
          <optgroup
            label={`WHOLESALE VENDORS (${groupedVendors.WHOLESALER.length})`}
            style={vendorStyles.optgroup}
          >
            {groupedVendors.WHOLESALER.map((vendor) => (
              <option
                key={vendor._id}
                value={vendor._id}
                style={vendorStyles.option}
              >
                {vendor.name}
              </option>
            ))}
          </optgroup>
        )}

        {groupedVendors.BRAND.length > 0 && (
          <optgroup
            label={`BRAND VENDORS (${groupedVendors.BRAND.length})`}
            style={vendorStyles.optgroup}
          >
            {groupedVendors.BRAND.map((vendor) => (
              <option
                key={vendor._id}
                value={vendor._id}
                style={vendorStyles.option}
              >
                {vendor.name}
              </option>
            ))}
          </optgroup>
        )}

        {groupedVendors.HEALTHCARE.length > 0 && (
          <optgroup
            label={`HEALTHCARE VENDORS (${groupedVendors.HEALTHCARE.length})`}
            style={vendorStyles.optgroup}
          >
            {groupedVendors.HEALTHCARE.map((vendor) => (
              <option
                key={vendor._id}
                value={vendor._id}
                style={vendorStyles.option}
              >
                {vendor.name}
              </option>
            ))}
          </optgroup>
        )}
      </AppSelect>
    </div>
  );
};

export default VendorSelector;

